<template>
    <a-modal
            :title="`${actType}优化师`"
            centered
            :width="640"
            :mask-closable="false"
            :visible="showunBindWorkForm"
            :confirmLoading="loading"
            @cancel="close"
    >
        <a-form-model
                ref="form"
                :model="model"
                :label-col="labelCol"
                :wrapper-col="wrapperCol"
        >
            <a-spin :spinning="loading">
                <a-form-model-item :label="`${actType}优化师`" prop="worker_id"  help="广告主解绑优化师后，该广告主的所有数据将不属于该优化师，请谨慎操作！！！">
                    <a-select placeholder="" :default-value="model.worker_id" show-search option-filter-prop="children"
                              v-model="model.worker_id">
                        <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
                            {{ worker.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-spin>
        </a-form-model>

        <template slot="footer">
            <a-button @click="close" :disabled="loading">取消</a-button>
            <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
        </template>
    </a-modal>
</template>

<style lang="less" scoped>
@import 'Bind';
</style>

<script>
import Bind from './Bind'

export default Bind
</script>
